import { render, staticRenderFns } from "./TaskListHeader.vue?vue&type=template&id=aefdd7c8&"
import script from "./TaskListHeader.vue?vue&type=script&lang=js&"
export * from "./TaskListHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aefdd7c8')) {
      api.createRecord('aefdd7c8', component.options)
    } else {
      api.reload('aefdd7c8', component.options)
    }
    module.hot.accept("./TaskListHeader.vue?vue&type=template&id=aefdd7c8&", function () {
      api.rerender('aefdd7c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskList/TaskListHeader.vue"
export default component.exports